import React from 'react';
import { Link } from 'react-router-dom';
import { string } from 'prop-types';
import Grid from '@material-ui/core/Grid';
import Typography from '@material-ui/core/Typography';
import Button from '@material-ui/core/Button';
import { withStyles } from '@material-ui/core/styles';
import { Translation } from 'react-i18next';

const styles = (theme) => ({
  container: {
    textAlign: 'left',
    padding: theme.spacing(4),
    borderTop: '5px solid #029E4A',
  },
  textField: {
    marginTop: theme.spacing(1),
    marginBottom: 0,
  },
  button: {
    marginTop: theme.spacing(2),
  },
  linkButton: {
    marginTop: theme.spacing(2),
  },
  h2: {
    fontWeight: 400,
  },
  h6: {
    fontWeight: 700,
  },
  body1: {
    marginLeft: theme.spacing(2),
  },
  saveButton: {
    background: '#0280CA',
    marginRight: theme.spacing(2),
    marginTop: theme.spacing(2),
    marginBottom: theme.spacing(2),
  },
  buttonContainer: {
    display: 'flex',
  },
});

const TermsAndConditions = ({ title, classes, isAuthenticated }) => (
  <Translation>
    {(t) => {
      return (
        <div className={classes.container}>
          <Typography variant="h2" color="inherit" classes={{ h2: classes.h2 }}>
            {t('termsHeader')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('termsSec1Title')}
          </Typography>
          <Typography variant="body1" gutterBottom color="inherit">
            {t('termsSec1Body1')}
          </Typography>
          <Typography variant="body1" gutterBottom color="inherit">
            {t('termsSec1Body2')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('termsSec2Title')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec2Body1')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec2Body2')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec2Body3')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec2Body4')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec2Body5')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('termsSec3Title')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec3Body1')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec3Body2')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec3Body3')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec3Body4')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec3Body5')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('termsSec4Title')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec4Body1')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec4Body2')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('termsSec5Title')}
          </Typography>
          <Typography
            variant="body1"
            gutterBottom
            color="inherit"
            classes={{ body1: classes.body1 }}
          >
            {t('termsSec5Body1')}
          </Typography>
          <Typography
            variant="h6"
            gutterBottom
            color="inherit"
            classes={{ h6: classes.h6 }}
          >
            {t('termsSec6Title')}
          </Typography>
          <Typography variant="body1" gutterBottom color="inherit">
            {t('termsSec6Body1')}
          </Typography>
          <Grid item className={classes.buttonContainer}>
            <Button
              variant="contained"
              color="primary"
              className={classes.saveButton}
              component={Link}
              to={'/applications'}
            >
              {isAuthenticated ? t('backTo') : t('back')}
            </Button>
          </Grid>
        </div>
      );
    }}
  </Translation>
);
TermsAndConditions.propTypes = {
  title: string,
};

TermsAndConditions.defaultProps = {
  title: '',
};

export default withStyles(styles)(TermsAndConditions);



// WEBPACK FOOTER //
// ./src/view/forms/TermsAndConditions/TermsAndConditions.js